import { WizardStep } from "@/components/organisms";
import { fakeI18n } from "@/i18n";

import { AuthorizationStep, CommunicationStep, DetailsStep, PreferenceStep } from "./steps";
import {
    formSchemaAuthorization,
    formSchemaCommunication,
    formSchemaDetails,
    formSchemaPreference,
} from "./steps/formSchema";

export enum StepId {
    Details = 0,
    Preference = 1,
    Authorization = 2,
    Communication = 3,
}

export const CustomerCardSteps: WizardStep[] = [
    {
        stepId: StepId.Details,
        stepBarId: StepId.Details,
        title: fakeI18n.t("CustomerCard.Steps.CustomerDetails"),
        component: DetailsStep,
        schema: formSchemaDetails,
    },
    {
        stepId: StepId.Preference,
        stepBarId: StepId.Preference,
        title: fakeI18n.t("CustomerCard.Steps.UsagePreference"),
        component: PreferenceStep,
        schema: formSchemaPreference,
    },
    {
        stepId: StepId.Authorization,
        stepBarId: StepId.Authorization,
        title: fakeI18n.t("CustomerCard.Steps.ConsultationAuthorization"),
        component: AuthorizationStep,
        schema: formSchemaAuthorization,
    },
    {
        stepId: StepId.Communication,
        stepBarId: StepId.Communication,
        title: fakeI18n.t("CustomerCard.Steps.CommunicationWithOurOffice"),
        component: CommunicationStep,
        schema: formSchemaCommunication,
    },
];
